// 登出按鈕
import { useDispatch } from 'react-redux';
import { userLogout } from '@/slices/userSlice';
import authClient from '@/common/apiClient/authClient';

const LogoutButton = ({ t, type, color = '#fff' }) => {
    const dispatch = useDispatch();
    // 登出
    const onLogout = async () => {
        try {
            const result = await authClient.logout();
            if (result) dispatch(userLogout());
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <button
            onClick={onLogout}
            className={`text-btn1 flex-shrink-0 text-white text-center block trans 
                ${
                    type === 'event'
                        ? 'px-5 py-2 h-[32px] rounded-[40px]'
                        : 'w-full py-[12px] rounded-[4px] bg-vPurple hover:bg-purple'
                }`}
            style={{ color: type === 'event' ? color : '' }}
        >
            {type === 'event' ? '登出' : t('LOGOUT')}
        </button>
    );
};

export default LogoutButton;
